import DOMPurify from 'dompurify'

/**
 * HTML sanitization — strips all tags except safe inline/block elements
 * and removes event handlers and dangerous URI schemes.
 *
 * Allowed tags: <a>, <p>, <br>, <span> (and their closing tags).
 *
 * @param html - Raw HTML string to sanitize
 * @param options.openLinksInNewTab - When true, adds target="_blank" rel="noopener noreferrer"
 *   to all <a> tags so links open in a new tab safely.
 */
export function sanitizeHtml(
    html: string,
    { openLinksInNewTab = false }: { openLinksInNewTab?: boolean } = {}
): string {
    // RETURN_DOM_FRAGMENT gives us a per-call DocumentFragment with no shared
    // global hook state — safe under concurrent React renders.
    const fragment = DOMPurify.sanitize(html, {
        ALLOWED_TAGS: ['a', 'p', 'br', 'span'],
        ALLOWED_ATTR: ['href', 'target', 'rel'],
        RETURN_DOM_FRAGMENT: true,
    })

    if (openLinksInNewTab) {
        fragment.querySelectorAll('a').forEach(a => {
            a.setAttribute('target', '_blank')
            a.setAttribute('rel', 'noopener noreferrer')
        })
    }

    const container = document.createElement('div')
    container.appendChild(fragment)
    return container.innerHTML
}
